import React from 'react';
import { useSearchParams, useParams, Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import AMBalances from './SectionsForWorkerMembershipFeesPage/AMBalances';
import NegativeBalances from './SectionsForWorkerMembershipFeesPage/NegativeBalances';
import TransactionsHistory from './SectionsForWorkerMembershipFeesPage/TransactionsHistory';
import SROAccountingDataMerge from './SectionsForWorkerMembershipFeesPage/SROAccountingDataMerge';

import HeadlinePanel from '../../Components/HeadlinePanel';

import subpageSelection from '../../styles/SubpageSelection.module.css';
import SROFinancialStatements from './SectionsForWorkerMembershipFeesPage/SROFinancialStatements';

const WorkerMembershipFees = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const section = searchParams.get('section') || 'am-balances';

    let { id: routeId } = useParams();
    const [id, setId] = React.useState(null);
    const [isMyAccount, setIsMyAccount] = React.useState(null);
    const [redirect, setRedirect] = React.useState(null);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            setRedirect('/auth/login');
            return;
        }

        try {
            const decodedToken = jwtDecode(token);

            if (routeId) {
                // Это не мой аккаунт
                setId(routeId);
                setIsMyAccount(false);

                if (decodedToken.role !== 'АппаратСРО') {
                    setRedirect('/404');
                }
            } else {
                // Это мой аккаунт
                setId(decodedToken.id);
                setIsMyAccount(true);
            }
        } catch (error) {
            console.error('Ошибка при декодировании токена: ', error);
            setRedirect('/home');
        }
    }, [routeId]);

    if (redirect) {
        return <Navigate to={redirect} replace />;
    }

    if (id === null || isMyAccount === null) {
        return <div>Загрузка...</div>;
    }


    return (
      <>
          <div className={subpageSelection.panel}>
                <a onClick={() => setSearchParams({ section: 'am-balances' })} className={`${subpageSelection.buttonToSubPages} ${section === 'am-balances' ? subpageSelection.active : ''}`}>Управляющие и их баланс</a>
                <a onClick={() => setSearchParams({ section: 'negative-balances' })} className={`${subpageSelection.buttonToSubPages} ${section === 'negative-balances' ? subpageSelection.active : ''}`}>Управляющие с отрицательным балансом</a>
                <a onClick={() => setSearchParams({ section: 'transactions-history' })} className={`${subpageSelection.buttonToSubPages} ${section === 'transactions-history' ? subpageSelection.active : ''}`}>История всех транзакций</a>
                <a onClick={() => setSearchParams({ section: 'sro-financial-statements' })} className={`${subpageSelection.buttonToSubPages} ${section === 'sro-financial-statements' ? subpageSelection.active : ''}`}>Использованные ведомости для объединения данных</a>
                <a onClick={() => setSearchParams({ section: 'sro-accounting-data-merge' })} className={`${subpageSelection.buttonToSubPages} ${section === 'sro-accounting-data-merge' ? subpageSelection.active : ''}`}>Загрузить ведомость для учета в системе</a>
          </div>
          <div className='pageWrapper'>
              {section == 'am-balances' ? <AMBalances />
              : section == 'negative-balances' ? <NegativeBalances />
              : section == 'transactions-history' ? <TransactionsHistory />
              : section == 'sro-financial-statements' ? <SROFinancialStatements />
              : section == 'sro-accounting-data-merge' ? <SROAccountingDataMerge />
              : <p className='description'>Выберите вкладку</p>}
          </div>
      </>
    )
}

export default WorkerMembershipFees;